import * as type from './type';
import util from 'common/js/util';

export default{
    //保存企业类型
    [type.SAVE_COMPANY_TYPE](context,option){
        util.post({
            params:{
                functionId: "saveCompanyType",
                body: JSON.stringify({
                    userType: context.state.form.userType,
                    invitationCode: context.state.form.invitationCode,
                })
            },
            sc (data){
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },
    [type.SAVE_COMPANY_LICENSE](context,option){
        util.post({
            params:{
                functionId: "saveCompanyLicense",
                body: JSON.stringify(Object.assign(context.state.form.companyLicence))
            },
            sc (data){
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },
    [type.SAVE_USER_LICENSE](context,option){
        util.post({
            params:{
                functionId: "saveUserLicense",
                body: JSON.stringify(Object.assign(context.state.form.userLicence))
            },
            sc (data){
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },
    [type.SAVE_DETAIL](context,option){
        util.post({
            params:{
                functionId: "saveQualificationInfo",
                body: JSON.stringify(Object.assign(context.state.form.qualificationInfo, option.params))
            },
            sc (data){
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },

    [type.GET_REGISTER_INFO](context,option){
        util.post({
            params: option.params,
            sc (data){
                // context.commit(type.SET_REGISTER_INFO, data.data);
                context.commit(type.FILL_COMPANY_TYPE, data.data.userType);
                context.commit(type.FILL_INVITATION_CODE, data.data.invitationCode);
                context.commit(type.FILL_COMPANY_INFO, data.data.companyLicence);
                context.commit(type.FILL_LEGAL_INFO, data.data.userLicence);
                context.commit(type.FILL_QUALIFY_INFO, data.data.qualificationInfo);
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },

    [type.VALIDATE_CODE](context, option){
        util.post({
            params:{
                functionId: "checkTaxPayNumberAvailable",
                body: JSON.stringify({
                    taxPayNumber: context.state.form.companyLicence.code
                })
            },
            sc (data){
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/store/register/actions.js